module.exports = require("@swa-ui/authentication/src/components/MfaHeading/MfaHeading.module.scss");